export default "__VITE_ASSET__MjgUYoKG__"